import approveSamplingReducer from "./approveSamplingReducer";

const approveSamplingReducers = {
    approveSampling: approveSamplingReducer
};

export default approveSamplingReducers;